/**
 * program
 * Program APIs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProgramPeriodMngDto } from './programPeriodMngDto';
import { ProgramContextActionsMngDto } from './programContextActionsMngDto';


export interface ProgramHeaderMngDto { 
    /**
     * The overall program status.
     */
    status: ProgramHeaderMngDto.StatusEnum;
    /**
     * The program status display text.
     */
    statusText: { [key: string]: string; };
    /**
     * The program title.
     */
    title: { [key: string]: string; };
    /**
     * The short summary of the program.
     */
    shortSummary?: { [key: string]: string; };
    /**
     * The program period information. Period represents a time-frame within the program.
     */
    period?: ProgramPeriodMngDto;
    /**
     * The overall actions for the program.
     */
    contextActions?: ProgramContextActionsMngDto;
}
export namespace ProgramHeaderMngDto {
    export type StatusEnum = 'active' | 'inactive' | 'cancelled';
    export const StatusEnum = {
        Active: 'active' as StatusEnum,
        Inactive: 'inactive' as StatusEnum,
        Cancelled: 'cancelled' as StatusEnum
    };
}


